import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';

import {PoDynamicFormField, PoLookupColumn, PoLookupFilter, PoLookupFilteredItemsParams} from '@po-ui/ng-components';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CondicaoPagamentoLookupService implements PoLookupFilter {
  url = `${environment.urlApiProtheus}/wsrcondpag`;

  constructor(private httpClient: HttpClient) {
  }

  getFilteredItems(filteredParams: PoLookupFilteredItemsParams): Observable<any> {
    const {filterParams, advancedFilters, ...restFilteredItemsParams} = filteredParams;
    const params = {...restFilteredItemsParams, ...filterParams, ...advancedFilters};

    return this.httpClient.get(this.url, {params});
  }

  getObjectByValue(value: string): Observable<any> {
    return this.httpClient.get(`${this.url}/${value}`);
  }

  getAdvancedFilter(): Array<PoDynamicFormField> {
    return [
      {property: 'CE4CODIGO', optional: true, gridColumns: 6, label: 'Código'},
      {property: 'CE4DESCRI', optional: true, gridColumns: 6, label: 'Descrição'},
    ];
  }

  getColumnsFilter(): Array<PoLookupColumn> {
    return [
      {property: 'CE4CODIGO', label: 'Código'   , width: '30%'},
      {property: 'CE4DESCRI', label: 'Descrição', width: '70%'},
    ];
  }

  getFieldFormater(value: any): string {
    return `${value.CE4CODIGO} - ${value.CE4DESCRI}`;
  }

}

export interface CondicaoPagamento {
  'CE4DESCRI': string;
  'CE4CODIGO': string;
}
